import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { useTheme } from 'foundations-theming/utils';
import { useMemo, useState } from 'react';
import { parseTextIfMarkers } from './parseTextWithMarkers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_VISIBLE_LINES = 5;
const BUTTON_HEIGHT_OFFSET = 40;
const TextFieldBlock = ({
  block,
  message,
  callbacks,
  sectionId
}) => {
  var _theme$typography$bod;
  const theme = useTheme();
  const lineHeight = parseFloat((_theme$typography$bod = theme.typography['body-100'].lineHeight) !== null && _theme$typography$bod !== void 0 ? _theme$typography$bod : '24');
  const textMaxHeight = Math.ceil(lineHeight * MAX_VISIBLE_LINES);
  const [isCollapsible, setIsCollapsible] = useState(false);
  const maxHeight = isCollapsible ? textMaxHeight + BUTTON_HEIGHT_OFFSET : textMaxHeight;
  const parsedValue = useMemo(() => parseTextIfMarkers(block.value, message, callbacks, sectionId), [block.value, message, callbacks, sectionId]);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "100",
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "detail-100",
      color: "text-core-subtle",
      children: block.label
    }), /*#__PURE__*/_jsx(ExpandableText, {
      maxHeight: maxHeight,
      hideButtonCaret: true,
      buttonAlign: "left",
      onCollapsibleChange: setIsCollapsible,
      children: parsedValue
    })]
  });
};
export default TextFieldBlock;